import { withStyles, Theme, createStyles } from '@material-ui/core';
import Tab from '@material-ui/core/Tab';

type FontWeight = 'normal' | 'bold' | 700;

export const PasslyTab = withStyles((theme: Theme) =>
    createStyles({
        root: {
            textTransform: 'none',
            minWidth: 72,
            fontWeight: theme.typography.fontWeightRegular as FontWeight,
            fontFamily: [
                'Roboto',
                'IBM Plex Sans',
                'Helvetica Neue',
                'Arial',
                'sans-serif',
                '"Apple Color Emoji"',
                '"Segoe UI Emoji"',
                '"Segoe UI Symbol"',
            ].join(','),
            '&:hover': {
                color: theme.palette.primary.main,
                opacity: 1,
            },
            '&$selected': {
                color: theme.palette.primary.main,
                fontWeight: theme.typography.fontWeightMedium,
            },
            '&:focus': {
                color: theme.palette.primary.main,
            },
        },
        selected: {},
    }),
)(Tab);